export const LIB_NAME = 'react-dropdown-select';
